import {z} from 'zod';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

export const APPROVE_CLAIM_TYPE = 'APPROVE_CLAIM_TYPE';
export const REJECT_CLAIM_TYPE = 'REJECT_CLAIM_TYPE';

export const decisionOnClaimModalFormTypeSchema = z
  .object({
    type: z
      .array(z.enum([APPROVE_CLAIM_TYPE, REJECT_CLAIM_TYPE]), {
        message: i18n.t('errors.field_is_required'),
      })
      .min(1)
      .max(1),
    reason: z.string().optional(),
    isDuplicateToOrder: z.boolean(),
    serviceOrderVariantId: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    const hasValidReason = !!data.reason?.trim();

    if (data.type.includes(REJECT_CLAIM_TYPE)) {
      if (!hasValidReason) {
        ctx.addIssue({
          path: ['reason'],
          code: z.ZodIssueCode.custom,
          message: i18n.t('errors.field_is_required'),
        });
      }
      if (data.isDuplicateToOrder && isNil(data.serviceOrderVariantId)) {
        ctx.addIssue({
          path: ['serviceOrderVariantId'],
          code: z.ZodIssueCode.custom,
          message: i18n.t('errors.field_is_required'),
        });
      }
    }
  });

export type DecisionOnClaimModalFormType = z.infer<typeof decisionOnClaimModalFormTypeSchema>;
